import React from "react";
import { Grid, Checkbox } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { getMessage } from "../../CommonFuntion/messages";

const LayoutApprovalSection = ({
  layoutInformation,
  layoutApproval,
  setLayoutApproval,
  setOrderOnHold,
  setLayoutApprovalChild,
  setOrderOnHoldChild,
  orderOnHold,
  isInteralOrAdminUser,
}) => {
  if (!layoutInformation.generateLayout) return null;

  return (
    <Grid item xs={24} sm={12} md={8}>
      <div className="flex-container2">
        <div className="flex-item-left2">
          Generate Layout Approval :
          <Checkbox
            checked={layoutApproval}
            name="layoutApproval"
            onChange={(event) => {
              const newValue = event.target.checked;
              setLayoutApproval(newValue);
              setOrderOnHold(newValue);
              setLayoutApprovalChild(newValue);
              setOrderOnHoldChild(newValue);
            }}
            disabled={layoutInformation.forceLayout}
          />
        </div>
        {isInteralOrAdminUser && (
          <div className="flex-item-left2">
            Place Order On Hold :
            <Checkbox
              checked={orderOnHold}
              onChange={(event) => setOrderOnHold(event.target.checked)}
              name="orderOnHold"
              disabled={layoutInformation.forceLayout}
            />
          </div>
        )}
      </div>
      <InfoIcon color="primary" />
      <span style={{ fontSize: 12, color: "red" }}>
        {getMessage("GenerateLayoutCheckoutMessage")}
      </span>
    </Grid>
  );
};

export default LayoutApprovalSection;
